import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {PatronBalanceTransaction} from '@store/account/account.types';
import {AccountSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-transaction-combined-name-item-title',
  styles: `
      div.mat-body-1 {
          margin-bottom: 0;
      }
  `,
  template: `
    <div class="flex-col mat-body-1">
      @if (transactionSelectors.showAmountsExpansionFor(transaction) | select) {
        Multiple
      } @else {
        <div>{{ transactionSelectors.nameFor(transaction) | select }}</div>
        <div>{{ transactionSelectors.itemTitleFor(transaction) | select }}</div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TransactionCombinedNameItemTitleComponent {
  @Input() transaction: PatronBalanceTransaction;
  public readonly transactionSelectors = AccountSelectors.BalanceTransactions;
}
